import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import useSWR from 'swr';

import { BatchDataProps } from 'containers/Inventory/type';
import { IDetailResponse, IPaginatedResponse } from 'utils/types';

import { fetcher } from './utils';

export interface InventoryLabel {
  id?: number;
  title: string;
}

export interface InventoryMerchant {
  id?: number;
  name?: string;
}

export interface IInventory {
  id: number;
  name: string;
  sku?: string | null;
  merchant?: InventoryMerchant | null;
  labels?: InventoryLabel[];
  uploaded?: number;
  unassigned?: number;
  issued_balance?: number;
  assigned?: number;
}

export const useInventoryList = (params: Record<string, any> = {}, shouldFetch: boolean = true) => {
  const sanitizedParams = omitBy(params, isNil);
  const key = shouldFetch ? { url: '/v4/dash/inventories', params: sanitizedParams } : null;
  const { data, isLoading, error, mutate, isValidating } = useSWR<IPaginatedResponse<IInventory>>(
    key,
    fetcher
  );

  return { data: data?.data, meta: data?.meta, isLoading, error, mutate, isValidating };
};

export const useInventory = (id?: number | string | null) => {
  const { data, isLoading, error, mutate, isValidating } = useSWR<IDetailResponse<IInventory>>(
    id ? `/v4/dash/inventories/${id}` : null,
    fetcher
  );

  return { data: data?.data, isLoading, error, mutate, isValidating };
};

export const useInventoryBatchList = (
  inventoryId?: number | string | null,
  params: Record<string, any> = {},
  shouldFetch: boolean = true
) => {
  const sanitizedParams = omitBy(params, isNil);
  const key =
    inventoryId && shouldFetch
      ? { url: `/v4/dash/inventories/${inventoryId}/batches`, params: sanitizedParams }
      : null;
  const { data, isLoading, error, mutate, isValidating } = useSWR<
    IPaginatedResponse<BatchDataProps>
  >(key, fetcher);

  return { data: data?.data, meta: data?.meta, isLoading, error, mutate, isValidating };
};
